import {StatusTypes} from "@dropDesk/domain/entities/chat/chat_enum";

export class ConnectionExtraInfoEntity {
    isConnectedToAnotherAccount?: boolean;
    lid?: string;

    constructor({isConnectedToAnotherAccount, lid}: {
        isConnectedToAnotherAccount?: boolean,
        lid?: string;
    }) {
        Object.assign(this, {
            isConnectedToAnotherAccount,
            lid
        });
    }

    public static fromJson(json: Record<string, any>): ConnectionExtraInfoEntity {
        return new ConnectionExtraInfoEntity({
            isConnectedToAnotherAccount: json['isConnectedToAnotherAccount'] ?? false,
            lid: json['lid'] ?? null
        });
    }
}

export class ChatIntegrationConnectionEntity {
    idCompany!: string;
    qrCode!: string | null;
    idConnection?: string;
    status!: StatusTypes;
    updatedAt?: string;
    createdAt?: string;
    extraInfo?: ConnectionExtraInfoEntity;

    public get hasActiveConnection(): boolean {
        return this.status === StatusTypes.CONNECTED;
    }

    public get duplicated(): boolean {
        return !!this.extraInfo?.isConnectedToAnotherAccount;
    }

    public get hasErrorConnection(): boolean {
        return this.status === StatusTypes.ERROR || this.status === StatusTypes.CRASHED;
    }

    public get hasInactiveConnection(): boolean {
        return this.status === StatusTypes.DISCONNECTED || this.status === StatusTypes.UNAUTHENTICATED ||
            this.status === StatusTypes.LOGGED_OUT;
    }

    public get isDisconnected(): boolean {
        return this.status === StatusTypes.DISCONNECTED;
    }

    public get isConnecting(): boolean {
        return this.status === StatusTypes.CONNECTING || this.status === StatusTypes.RECONNECTING;
    }

    public get isTimeout(): boolean {
        return this.status === StatusTypes.TIMED_OUT;
    }

    public get numberConnected(): string | undefined {
        if (!this.idConnection) {
            return;
        }
        return this.idConnection.split('@')[0].split(':')[0];
    }

    static fromJson(json: Record<string, any>): ChatIntegrationConnectionEntity {
        return new ChatIntegrationConnectionEntity({
            idCompany: json['idCompany'] as string,
            qrCode: json['qrCode'] as string,
            idConnection: json['idConnection'] as string,
            status: json['status'] as StatusTypes,
            updatedAt: json['updatedAt'] as string,
            createdAt: json['createdAt'] as string,
            extraInfo: json['extraInfo'] ? ConnectionExtraInfoEntity.fromJson(json['extraInfo']) : undefined,
        });
    }

    constructor({
                    idCompany,
                    qrCode,
                    idConnection,
                    status,
                    updatedAt,
                    createdAt,
                    extraInfo
                }: {
        idCompany: string;
        qrCode: string | null;
        idConnection?: string;
        status: StatusTypes;
        updatedAt?: string;
        createdAt?: string;
        extraInfo?: ConnectionExtraInfoEntity;
    }) {
        Object.assign(this, {
            idCompany,
            qrCode,
            idConnection,
            status,
            updatedAt,
            createdAt,
            extraInfo
        });
    }

    copyWith({
                 idCompany,
                 qrCode,
                 idConnection,
                 status,
                 updatedAt,
                 createdAt,
                 extraInfo
             }: {
        idCompany?: string;
        qrCode?: string | null;
        idConnection?: string;
        status?: StatusTypes;
        updatedAt?: string;
        createdAt?: string;
        extraInfo?: ConnectionExtraInfoEntity;

    }): ChatIntegrationConnectionEntity {
        return new ChatIntegrationConnectionEntity({
            idCompany: idCompany ?? this.idCompany,
            qrCode: qrCode ?? this.qrCode,
            idConnection: idConnection ?? this.idConnection,
            status: status ?? this.status,
            updatedAt: updatedAt ?? this.updatedAt,
            createdAt: createdAt ?? this.createdAt,
            extraInfo: extraInfo ?? this.extraInfo,
        })
    }
}
